/*global define */
define(
	'jsonClone',[
		'underscore'
	],
	function (_) {
		/**
		 * Returns a Javascript object that represents a given javascript object (without preserving functions though).
		 * Nested object attributes are also truly cloned (not doing a shallow copy unlike Underscore.clone()).
		 * @param {Object} source
		 * @returns {Object}
		 */
		var jsonClone = function (source) {
			return JSON.parse(JSON.stringify(source));
		};

		// add this to underscore
		_.mixin({
			jsonClone: jsonClone
		});

		return jsonClone;
	});

